import { render, staticRenderFns } from "./LabelsConfig.vue?vue&type=template&id=0cb60090"
import script from "./LabelsConfig.vue?vue&type=script&lang=js"
export * from "./LabelsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb60090')) {
      api.createRecord('0cb60090', component.options)
    } else {
      api.reload('0cb60090', component.options)
    }
    module.hot.accept("./LabelsConfig.vue?vue&type=template&id=0cb60090", function () {
      api.rerender('0cb60090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionConfig/LabelsConfig.vue"
export default component.exports